import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutIntellirouteCityQuickInfo extends Layout {
    panelQuickInfo: Panel;
    sourceIntellirouteCity: DataSource;
    textboxCounty: Textbox;
    textboxId: Textbox;
    textboxName: Textbox;
    textboxStateId: Textbox;
    textboxZipCode: Textbox;
}
